import React from 'react';
import TripScheduleDetailPanel from './TripScheduleDetailPanel';

const TripScheduleBrowseLayout = ({
  schedule,
  selectedTrip,
  panelProps,
}) => (
  <div className="space-y-8">
    <div>{schedule}</div>
    {selectedTrip && (
      <TripScheduleDetailPanel
        trip={selectedTrip}
        className="max-w-4xl mx-auto w-full"
        {...panelProps}
      />
    )}
  </div>
);

export default TripScheduleBrowseLayout;
